import styled from 'styled-components';
import { Screens } from 'core/CssVariables';
import Alert from 'components/Alert/Alert';

const SHeaderAlert = styled(Alert)`
  margin-bottom: 0px;
  /* The dashbar sits flush against the side panel now (ZEST-757), so the alert
     stacked above it has to as well or the two edges disagree. */
  margin-left: 0;
  border-radius: 0px;

  /* ZEST-793: the design's announcement strip is a solid #1A3A5C band with
     white text (node 836:32460), and the dark frames use the same fill, so it
     is one colour in both themes rather than antd's 10% tint of the info
     colour.

     ZEST-797 narrows this to the announcement itself. Scoping it to the info
     type alone also caught the timezone prompt, which shares this component
     and, unlike the announcement, carries buttons: on the navy band its
     primary sat at 1.57:1 and its outlined one at 1.85:1, so both stopped
     reading as buttons. The design describes one banner and no error or
     timezone variant, so navy is the announcement treatment and everything
     else keeps antd's semantic tint.

     ZEST-800 themes the band instead: light keeps the design's navy and
     extends it to the timezone prompt, dark gives both a light panel. The
     timezone prompt's buttons are re-coloured below so they keep reading as
     buttons on either, which is what kept them off the band before. */

  /* Plain info banners. The announcement and infoBanner keys hold the same values
     today, so the override below is a no-op; both keys are kept because the
     trial band is the design's announcement and may diverge from the prompt
     again. The announcement rule carries two classes, so it outranks this. */
  &.ant-alert-info {
    background-color: ${({ theme }) => theme.infoBanner.backgroundColor};

    .ant-alert-message .ant-typography {
      color: ${({ theme }) => theme.infoBanner.color};
    }

    /* The outlined action sits on the banner, not the page, so it takes the
       banner's ink rather than the global default grey (#606060). That grey
       measured 1.85:1 on the navy band and reads washed out on the light
       panel; the banner's own text colour is legible on both by definition. */
    button[outline='true'] {
      color: ${({ theme }) => theme.infoBanner.color};
      border-color: ${({ theme }) => theme.infoBanner.color};

      &:hover,
      &:focus {
        color: ${({ theme }) => theme.infoBanner.color};
        border-color: ${({ theme }) => theme.infoBanner.color};
        opacity: 0.8;
      }
    }

    /* The filled action is inverted from the banner: the banner's ink becomes
       the button surface, the banner's background becomes its label. Its own
       #01579B fill measured 1.57:1 against the navy band (ZEST-797), so the
       shape read as part of the strip rather than as a button. Inverting keeps
       it correct if the banner colours change again. */
    button:not([outline='true']) {
      background-color: ${({ theme }) => theme.infoBanner.color};
      border-color: ${({ theme }) => theme.infoBanner.color};
      color: ${({ theme }) => theme.infoBanner.backgroundColor};

      &:hover,
      &:focus {
        background-color: ${({ theme }) => theme.infoBanner.color};
        border-color: ${({ theme }) => theme.infoBanner.color};
        color: ${({ theme }) => theme.infoBanner.backgroundColor};
        opacity: 0.8;
      }
    }
  }

  &.announcement.ant-alert-info {
    background-color: ${({ theme }) => theme.announcement.backgroundColor};
    border-color: ${({ theme }) => theme.announcement.backgroundColor};

    .ant-alert-message .ant-typography {
      color: ${({ theme }) => theme.announcement.color};
    }
  }

  @media (max-width: ${Screens.ScreensMD}) {
    margin-left: 0;
  }
`;

export { SHeaderAlert };
